module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "wrapper"
  }, [_c('img', {
    directives: [{
      name: "tap",
      rawName: "v-tap",
      value: ({
        methods: _vm.close
      }),
      expression: "{methods:close}"
    }],
    style: (_vm.styleObj),
    attrs: {
      "src": _vm.img,
      "alt": ""
    }
  }), _vm._v(" "), _c('i', {
    directives: [{
      name: "tap",
      rawName: "v-tap",
      value: ({
        methods: _vm.handlePre
      }),
      expression: "{methods:handlePre}"
    }],
    staticClass: "left"
  }), _vm._v(" "), _c('i', {
    directives: [{
      name: "tap",
      rawName: "v-tap",
      value: ({
        methods: _vm.handleNext
      }),
      expression: "{methods:handleNext}"
    }],
    staticClass: "right"
  })])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4b6b4b8b"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/PictureView.vue
// module id = 777
// module chunks = 1